import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default function initTestimonialCarousel() {
  const wrappers = document.querySelectorAll(".testimonial-swiper-wrapper");

  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const swiperContainer = wrapper.querySelector(".swiper");
    const progressBar = wrapper.querySelector(".carousel-progress-bar");
    const nextButton = wrapper.querySelector(".carousel-button-next");
    const prevButton = wrapper.querySelector(".carousel-button-prev");
    const carouselControls = wrapper.querySelector(".carousel-controls");

    if (!swiperContainer) return;

    new Swiper(swiperContainer, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 24,
      grabCursor: true,
      loop: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        init: function () {
          updateProgressBar(this, progressBar);
          updateControlsVisibility(this, carouselControls);
        },
        slideChange: function () {
          updateProgressBar(this, progressBar);
        },
      },
    });
  });

  function updateProgressBar(swiperInstance, progressBar) {
    if (!progressBar) return;
    const totalSlides = swiperInstance.slides.length;
    const currentIndex = swiperInstance.realIndex + 1;
    const progress = (currentIndex / totalSlides) * 100;
    progressBar.style.width = `${progress}%`;
  }

  function updateControlsVisibility(swiperInstance, controls) {
    if (!controls) return;
    if (swiperInstance.slides.length <= 1) {
      controls.style.display = "none";
    } else {
      controls.style.display = "";
    }
  }
}
